import {OptionalMapping} from "@app/models/optional-mappings";

export class CatalogMapping {
  generalMappings: any[];
  optionalMappings: OptionalMapping[];
  constructor() {
  }
}
